import moment from 'moment'
import redirect from '../../lib/redirect'
import fetch from 'isomorphic-unfetch'
import lunr from 'lunr'
import _, { debounce } from 'lodash'
import { validateToken, getClientConfig } from '../../utils/helpers'
import { getHeadersForApiCall, track } from '../../utils/api'

export const actionTypes = {
  SET_INDEX: 'SET_INDEX',
  LOAD_INITIAL_ELEMENTS: 'LOAD_INITIAL_ELEMENTS',
  SET_REPORT_WINDOW_URL: 'SET_REPORT_WINDOW_URL',
  FETCH_ELEMENTS: 'FETCH_ELEMENTS',
  FILTER_ELEMENTS: 'FILTER_ELEMENTS',
  SET_FILTERING: 'SET_FILTERING',
  ELEMENTS_CACHED: 'ELEMENTS_CACHED',
  UPDATE_SOURCE_FILTER: 'UPDATE_SOURCE_FILTER',
  UPDATE_SEARCH_TEXT: 'UPDATE_SEARCH_TEXT',
  TOGGLE_CONTEXT_PANE: 'TOGGLE_CONTEXT_PANE',
  TOGGLE_DATA_DIRECTORY: 'TOGGLE_DATA_DIRECTORY',
  SET_CURRENT_ELEMENT: 'SET_CURRENT_ELEMENT',
  CLEAR_CURRENT_ELEMENT: 'CLEAR_CURRENT_ELEMENT',
  INIT_CONTEXT_PANE: 'INIT_CONTEXT_PANE',
  INIT_DATA_DIRECTORY: 'INIT_DATA_DIRECTORY',
  AUTHENTICATING: 'AUTHENTICATING',
  LOG_IN: 'LOG_IN',
  CHECK_AUTH: 'CHECK_AUTH',
  LOG_OUT: 'LOG_OUT',
  SET_TOKENS: 'SET_TOKENS',
  REMOVE_TOKENS: 'REMOVE_TOKENS',
  SET_USER_DATA: 'SET_USER_DATA',
  CLEAR_USER_DATA: 'CLEAR_USER_DATA',
  TEST_ACTION: 'TEST_ACTION',
}

export const filterElements = debounce((dispatch, getState, searchText) => {
  const state = getState()
  const { searchIndex, elements } = state.dataDirectory
  let searchResults
  if (searchText.length > 0) {
    const searchTerms = searchText
      .trim()
      .split(' ')
      .map(term => `+*${term}*`)
    const results = searchIndex.search(searchTerms.join(' '))
    const elementRefs = results.map(element => element.ref)
    searchResults = elements.filter(element => elementRefs.includes(element.uuid))
  } else {
    searchResults = elements
  }
  return dispatch({ type: actionTypes.FILTER_ELEMENTS, payload: searchResults })
}, 200)

export function asyncFilterElements(searchText = '') {
  return (dispatch, getState) => {
    //throttleSetFiltering(dispatch, text)
    Promise.resolve(dispatch(updateSearchText(searchText))).then(
      filterElements(dispatch, getState, searchText)
    )

    return dispatch({ type: actionTypes.TEST_ACTION })
  }
}

export function loadInitialElements(elementId) {
  return (dispatch, getState) => {
    Promise.resolve(dispatch(fetchElements()))
      .then(args => {
        const elements = args.payload
        dispatch(setIndex(elements))
        dispatch(setCurrentElement(elementId))
      })
      .then(() => {
        dispatch(asyncFilterElements())
      })
  }
}

export const enrichElements = elements => {
  return elements.map(element => {
    const { name, source, description, owner_email, path } = element
    const defaultPath = path || []
    return {
      ...element,
      source: `${element.source[0].toUpperCase()}${element.source.slice(1)}`,
      searchTokens: `${name || ''} ${source || ''} ${description || ''} ${owner_email ||
        ''} ${defaultPath.join(' ') || ''} `.trim(),
    }
  })
}

export function fetchElements() {
  return (dispatch, getState) => {
    const state = getState()
    const { email } = state.user
    const { currentElement } = state.dataDirectory
    return fetchElementsApiCall()
      .then(res => res.json())
      .then(data => {
        const elements = enrichElements(data)
        return dispatch({
          type: actionTypes.FETCH_ELEMENTS,
          payload: elements,
        })
      })
  }
}

export const fetchElementsApiCall = () => {
  return fetch('/static/report_elements.json')
}

export function setCurrentElement(elementId) {
  return (dispatch, getState) => {
    const state = getState()
    const { elements } = state.dataDirectory
    const newElement = _.find(elements, {
      uuid: elementId,
    })
    if (!!newElement) {
      const { REPORTZ_URL } = getClientConfig()
      newElement.url = newElement.url.replace('https://reportz.staging.mntd.net', REPORTZ_URL)
    }
    return Promise.resolve(
      dispatch({
        type: actionTypes.SET_CURRENT_ELEMENT,
        payload: newElement,
      })
    ).then(dispatch(setReportWindowUrl()))

    //return dispatch({
    //type: actionTypes.SET_CURRENT_ELEMENT,
    //payload: newElement,
    //})
  }
}

export function clearCurrentElement() {
  return {
    type: actionTypes.CLEAR_CURRENT_ELEMENT,
  }
}

export function updateSourceFilter(source = 'reportz') {
  return {
    type: actionTypes.UPDATE_SOURCE_FILTER,
    payload: source,
  }
}

export function setIndex(elements) {
  const builder = new lunr.Builder()
  builder.ref('uuid')
  builder.field('searchTokens')
  _.each(elements, element => builder.add(element))
  return dispatch => dispatch({ type: actionTypes.SET_INDEX, payload: builder.build() })
}

export function updateSearchText(text = '') {
  return dispatch => {
    dispatch({ type: actionTypes.UPDATE_SEARCH_TEXT, payload: text })
  }
}

export function toggleDocked(pane) {
  const actionType = `TOGGLE_${pane}`
  return {
    type: actionTypes[actionType],
  }
}

export function initDocked(pane, docked) {
  const actionType = `INIT_${pane}`
  return {
    type: actionTypes[actionType],
    payload: docked,
  }
}

export const setTokens = authResult => {
  localStorage.setItem('accessToken', authResult.accessToken)
  localStorage.setItem('idToken', authResult.idToken)
  // Just for the log
  return { type: actionTypes.SET_TOKENS }
}

export const removeTokens = () => {
  localStorage.removeItem('idToken')
  localStorage.removeItem('accessToken')
  // Just for the log
  return { type: actionTypes.REMOVE_TOKENS }
}

export const logIn = authResult => {
  return dispatch => {
    Promise.resolve(dispatch(setTokens(authResult)))
      .then(dispatch(setUserData()))
      .then(redirect({}, '/'))
  }
}

export const clearElementsCache = () => {
  localStorage.removeItem('navElements')
}

export const logOut = () => {
  return dispatch => {
    dispatch(removeTokens())
    dispatch(clearUserData())
    clearElementsCache()
    redirect({}, '/login')
    return dispatch({ type: actionTypes.LOG_OUT })
  }
}

export const setUserData = () => dispatch => {
  let userData = validateToken()
  userData = !!userData ? { ...userData, isAuthenticated: true } : userData
  dispatch({ type: actionTypes.SET_USER_DATA, payload: userData })
  if (!userData) {
    dispatch(logOut())
  }
}

export const clearUserData = () => {
  return { type: actionTypes.CLEAR_USER_DATA }
}

export const checkAuthAndRedirect = () => (dispatch, getState) => {
  Promise.resolve(dispatch(setUserData())).then(() => {
    const state = getState()
    const { isAuthenticated } = state.user
    if (isAuthenticated) {
      return dispatch({ type: actionTypes.CHECK_AUTH })
    } else {
      dispatch(logOut())
      return dispatch({ type: actionTypes.CHECK_AUTH })
    }
  })
}

export const getSignedLookerUrlApiCall = lookerUrl => {
  return fetch(lookerUrl, {
    method: 'GET',
    headers: getHeadersForApiCall(),
  })
}

export function setReportWindowUrl() {
  return (dispatch, getState) => {
    const { LOOKER_SSO_API_URL } = getClientConfig()
    const idToken = typeof window === 'undefined' ? '' : localStorage.getItem('idToken')
    const accessToken = typeof window === 'undefined' ? '' : localStorage.getItem('accessToken')
    const { currentElement } = getState().dataDirectory
    if (currentElement) {
      switch (currentElement.source) {
        case 'Looker':
          const lookerReportPath = currentElement.url
            .replace('https://minted.looker.com', '')
            .replace('?allow_login_screen=true', '')
          const url = `${LOOKER_SSO_API_URL}?path=${lookerReportPath}`
          return getSignedLookerUrlApiCall(url)
            .then(res => res.json())
            .then(data => {
              dispatch({ type: actionTypes.SET_REPORT_WINDOW_URL, payload: data })
            })
        case 'Reportz':
          const reportzUrl = currentElement.url
          return dispatch({
            type: actionTypes.SET_REPORT_WINDOW_URL,
            payload: `${reportzUrl}?token=${accessToken}`,
          })
        default:
          return dispatch({
            type: actionTypes.SET_REPORT_WINDOW_URL,
            payload: currentElement.url,
          })
      }
    }
    return dispatch({
      type: actionTypes.SET_REPORT_WINDOW_URL,
      payload: '',
    })
  }
}

export const trackReportVisit = elementId => {
  return (dispatch, getState) => {
    const { email } = getState().user
    const eventType = 'elementView'
    const timestamp = moment.utc().format()
    const payload = {
      eventType,
      timestamp,
      email,
      elementId,
    }
    track(payload)
    return {}
  }
}
